export default {
  DateReceivedFrom: 'Date Received From',
  DateReceivedTo: 'Date Received To',
  keyword: 'Key Word',
  HeaderSearching: 'Searching for Pathologist Data',
}
